var render, staticRenderFns
import script from "./comment_ai_banner.vue?vue&type=script&lang=js&"
export * from "./comment_ai_banner.vue?vue&type=script&lang=js&"
import style0 from "./comment_ai_banner.vue?vue&type=style&index=0&id=421fe170&scoped=true&lang=css&"
import style1 from "./comment_ai_banner.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "421fe170",
  null
  
)

export default component.exports